import * as React from 'react';
import './index.css';
import { RichText } from '@wmfe/mach-pro-components-react';
import { highlightListForText } from '@/common/Highlight';

interface IState {}

interface Props {
  model: any;
}

export default class ShopScoreItemView extends React.Component<Props, IState> {
  render() {
    const { model } = this.props;
    const textName = model.textName;
    const icon = model.icon;
    return (
      <view className="shop-score-item-container">
        <view className="shop-score-item-icon-wrapper" style={{ top: Mach.env.isIOS ? 0.5 : 0.5 }}>
          <image className="shop-score-item-icon" src={icon} />
        </view>
        <view className="shop-score-item-text-wrapper">
          <text className="shop-score-item-text" content={textName} />
        </view>
      </view>
    );
  }
}
